var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"pointer",attrs:{"src":"/assets/img/edit.png","alt":"update tax","width":"25px"},on:{"click":_vm.openUpdateParamerModal}}),_c('AddProviderParametersModal',{attrs:{"id":`upd${_vm.parameter.id}`,"closeModal":_vm.closeModal,"provider":_vm.provider,"parameter":_vm.parameter,"refetch":_vm.refetch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }